function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clone, isNil, pathOr, propEq } from 'ramda';
import { i18n, PermissionService, SessionSelectors } from 'invision-core';
import { clearEWalletError } from '../../reducers/actions/customer.ewallet.actions';
import { SelectedPaymentMethodSelector, PaymentInstrumentsWithTypeNamesViewModel } from '../../reducers/selectors/customer.ewallet.selectors';
import { isEditablePaymentInstrumentType, isLockedPaymentInstrument } from '../../reducers/helpers/ewallet.reducer.helper';
import { SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from '../customer/ewallet/ewallet.constants';
import { BLANK_PAYMENT_INSTRUMENT, PAYMENT_METHOD_STATUSES } from './payment.method.switcher.constants';
import LocaleKeys from '../../locales/keys';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { ADDRESS_ACCESS, E_WALLET_ADMIN_ACCESS, PAYMENT_INSTRUMENT_ADMIN_ACCESS } from '../../security.attributes';
import { CurrentHouseholdSelector, CurrentMemberHasCreatePaymentInstrumentPermissionsSelector, CurrentMemberPrivilegesSelector } from '../../reducers/selectors/customer.household.selectors';
import { IsPIIDataAccessEnabledSelector } from '../../reducers/selectors/customer.selectors';
var PaymentMethodSwitcherController = /*#__PURE__*/function () {
  function PaymentMethodSwitcherController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, PaymentMethodSwitcherController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      currentInstrumentForEditing: null,
      filterAutopay: false,
      isEditingPaymentInstrument: false,
      LocaleKeys: LocaleKeys,
      showPaymentInstrumentForm: false,
      showSavePaymentInstrument: false,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(PaymentMethodSwitcherController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentHousehold: CurrentHouseholdSelector(store),
          currentMemberHasCreatePaymentInstrumentPermissions: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currentMemberPrivileges: CurrentMemberPrivilegesSelector(store),
          selectedPaymentMethod: SelectedPaymentMethodSelector(store),
          unfilteredPaymentInstruments: PaymentInstrumentsWithTypeNamesViewModel(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store)
        };
      };
      var controllerActions = {
        clearEWalletError: clearEWalletError,
        fetchCodeTypes: fetchCodeTypes
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.LocaleKeys = LocaleKeys;
      this.changePaymentPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.changePaymentPopupApi = event.api;
        }
      };
      this.createOrEditPaymentMethodPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.createOrEditPaymentMethodPopupApi = event.api;
        }
      };
      this.closeChangePaymentMethodPopup = function () {
        if (_this.changePaymentPopupApi.close) {
          _this.changePaymentPopupApi.close();
        }
        _this.actions.clearEWalletError();
        _this.showChangePaymentPopup = false;
      };
      this.closeCreateOrEditPaymentMethodPopup = function () {
        if (_this.createOrEditPaymentMethodPopupApi.close) {
          _this.createOrEditPaymentMethodPopupApi.close();
        }
        _this.actions.clearEWalletError();
        _this.isEditingPaymentInstrument = false;
        _this.showPaymentInstrumentForm = false;
      };
      this.onChangePaymentMethodComplete = function (paymentInstrument) {
        _this.closeChangePaymentMethodPopup();
        _this.onChange()(paymentInstrument);
      };
      this.onCreateOrEditPaymentMethodComplete = function (paymentInstrument) {
        if (_this.isEditingPaymentInstrument) {
          _this.onEdit()(paymentInstrument);
        } else {
          _this.onNew()(paymentInstrument);
        }
        _this.closeCreateOrEditPaymentMethodPopup();
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.closeChangePaymentMethodPopup();
      this.closeCreateOrEditPaymentMethodPopup();
      this.disconnectRedux();
    }
  }, {
    key: "hasChangePaymentInstrument",
    value: function hasChangePaymentInstrument() {
      return typeof this.canChangePaymentInstrument !== 'undefined' ? this.canChangePaymentInstrument : true;
    }
  }, {
    key: "hasPaymentInstrumentAdminAccess",
    value: function hasPaymentInstrumentAdminAccess() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, PAYMENT_INSTRUMENT_ADMIN_ACCESS);
    }
  }, {
    key: "hasEwalletAdminAccess",
    value: function hasEwalletAdminAccess() {
      return PermissionService.hasAdminAccess(this.state.userSecurityAttributes, E_WALLET_ADMIN_ACCESS);
    }
  }, {
    key: "hasAddressAccess",
    value: function hasAddressAccess() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, ADDRESS_ACCESS);
    }
  }, {
    key: "addressAccessTooltipText",
    value: function addressAccessTooltipText() {
      return i18n.translate('You don\'t have address access to add a new payment method');
    }
  }, {
    key: "getCurrentPaymentInstrument",
    value: function getCurrentPaymentInstrument() {
      if (this.state.unfilteredPaymentInstruments && this.currentInstrumentId) {
        var match = this.state.unfilteredPaymentInstruments.find(propEq(this.currentInstrumentId, 'Id'));
        var paymentInstrument = match ? match : this.state.selectedPaymentMethod;
        if (this.hasAddressAccess()) {
          return paymentInstrument;
        } else {
          // Don't show address details when user don't have address access.
          paymentInstrument.BillingAddress = undefined;
          return paymentInstrument;
        }
      }
      return null;
    }
  }, {
    key: "isCurrentPaymentInFilteredList",
    value: function isCurrentPaymentInFilteredList() {
      if (this.currentInstrumentId) {
        return this.paymentInstruments.find(propEq(this.currentInstrumentId, 'Id'));
      }
      return false;
    }
  }, {
    key: "hasMultiplePaymentInstruments",
    value: function hasMultiplePaymentInstruments() {
      return pathOr(0, ['length'], this.paymentInstruments) > 1 || pathOr(0, ['length'], this.paymentInstruments) > 0 && !this.isCurrentPaymentInFilteredList();
    }
  }, {
    key: "hasAvailablePaymentInstrument",
    value: function hasAvailablePaymentInstrument() {
      return pathOr(0, ['length'], this.paymentInstruments) > 0 && !this.getCurrentPaymentInstrument();
    }
  }, {
    key: "currentInstrumentIsLocked",
    value: function currentInstrumentIsLocked() {
      return isLockedPaymentInstrument(this.getCurrentPaymentInstrument());
    }
  }, {
    key: "showEdit",
    value: function showEdit() {
      var currentPaymentInstrument = this.getCurrentPaymentInstrument();
      var isRemoved = currentPaymentInstrument && currentPaymentInstrument.Status === PAYMENT_METHOD_STATUSES.REMOVED;
      return !this.isReadOnly && !isRemoved && this.showNew() &&
      // Edit follows same permission rules as New,
      currentPaymentInstrument &&
      // plus need to account for missing PI,
      !this.currentInstrumentIsLocked() &&
      // and needs to account for locked PI,
      isEditablePaymentInstrumentType(currentPaymentInstrument.Type) && (
      // and whether the PI type is editable,
      // including EGCs which are only editable if they have an address
      String(currentPaymentInstrument.Type) !== SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD || currentPaymentInstrument.BillingAddress) && this.state.isPIIDataAccessEnabled;
    }
  }, {
    key: "showNew",
    value: function showNew() {
      return !this.isReadOnly && this.hasEwalletAdminAccess() && this.hasPaymentInstrumentAdminAccess() && this.canCreatePaymentInstruments() && this.state.isPIIDataAccessEnabled;
    }
  }, {
    key: "showLocked",
    value: function showLocked() {
      return this.currentInstrumentIsLocked();
    }
  }, {
    key: "showChange",
    value: function showChange() {
      return !this.isReadOnly && this.hasMultiplePaymentInstruments() && this.hasChangePaymentInstrument();
    }
  }, {
    key: "showFirstDiv",
    value: function showFirstDiv() {
      return (this.showEdit() || this.showLocked()) && (this.showChange() || this.showNew());
    }
  }, {
    key: "showSecondDiv",
    value: function showSecondDiv() {
      return this.showChange() && this.showNew();
    }
  }, {
    key: "openCreatePaymentMethodPopup",
    value: function openCreatePaymentMethodPopup() {
      var _this2 = this;
      this.setupEditPaymentInstrument(BLANK_PAYMENT_INSTRUMENT);
      this.showPaymentInstrumentForm = true;
      this.$timeout(function () {
        _this2.createOrEditPaymentMethodPopupApi.open();
      });
    }
  }, {
    key: "openEditPaymentMethodPopup",
    value: function openEditPaymentMethodPopup() {
      var _this3 = this;
      this.setupEditPaymentInstrument(this.getCurrentPaymentInstrument());
      this.showPaymentInstrumentForm = true;
      this.isEditingPaymentInstrument = true;
      this.$timeout(function () {
        _this3.createOrEditPaymentMethodPopupApi.open();
      });
    }
  }, {
    key: "openChangePaymentMethodPopup",
    value: function openChangePaymentMethodPopup() {
      var _this4 = this;
      this.showChangePaymentPopup = true;
      this.$timeout(function () {
        _this4.changePaymentPopupApi.open();
      });
    }
  }, {
    key: "setupEditPaymentInstrument",
    value: function setupEditPaymentInstrument(paymentInstrument) {
      this.currentInstrumentForEditing = clone(paymentInstrument);
      if (this.currentInstrumentForEditing.CreditCard && !isNil(this.currentInstrumentForEditing.CreditCard.Type)) {
        this.currentInstrumentForEditing.CreditCard.Type = Number.parseInt(this.currentInstrumentForEditing.CreditCard.Type, 10);
      }
    }

    /*
        This function was debated over a few times as to whether it should be included in the component, or
        in the consumers of the component. From a hipchat conversation with Kelly, she said it was safe to assume
        that everywhere that is using the switcher will have to take into account households.
         The decision was made that this is an ok place for the logic to exist right now.
         At the same time, it was realized that it might need to be changed if future scenarios discover a
        case where household needs to not be included.
    */
  }, {
    key: "canCreatePaymentInstruments",
    value: function canCreatePaymentInstruments() {
      if (this.state.currentHousehold) {
        return this.state.currentMemberHasCreatePaymentInstrumentPermissions;
      } else {
        return true;
      }
    }
  }]);
}();
export default {
  template: require('./payment.method.switcher.html'),
  bindings: {
    canChangePaymentInstrument: '<',
    currentInstrumentId: '<',
    filterAutopay: '<?',
    hasAdditionalInstruments: '<?',
    //This binding supports the one-off instances where the switcher needs to display additional messaging if other payment instruments exist but have all been used,
    isReadOnly: '<',
    onChange: '&',
    onEdit: '&',
    onNew: '&',
    paymentInstruments: '<',
    showSavePaymentInstrument: '<?'
  },
  controllerAs: 'PaymentMethodSwitcherController',
  controller: PaymentMethodSwitcherController
};